import { useEffect, useRef } from "react";

export function useUnmounted() {
	const unmounted = useRef(false);

	useEffect(() => {
		return () => {
			unmounted.current = true;
		};
	}, []);

	return unmounted;
}
